<template>
  <div class="console-container">
    <div v-if="!isLogginApp && route.path === '/console/app-list'">
      <div class="sub-menu-title">
        {{ $t('app_list.title') }}
      </div>
      <div class="login-app-container">
        <div class="mb-16 title-login-app">
          {{ $t('login_olsera.title') }}
        </div>
        <div class="mb-40">
          {{ $t('login_olsera.description') }}
        </div>
        <div>
          <el-button type="success" @click="handleLoginApp">
            {{ $t('login_olsera.button_loggin_account') }}
          </el-button>
        </div>
      </div>
    </div>
    <div v-if="isLogginApp && route.path === '/console/app-list'">
      <div class="sub-menu-title">
        {{ $t('app_list.title') }}
        <div class="flex-grow-1"></div>
        <el-button :loading="loadingLogoutOlsera" class="btn-app-list" type="default" style="margin-right: 12px;" @click="handleLogoutOlsera">
          Logout Olsera
        </el-button>
        <el-button class="btn-app-list" type="success" style="margin-right: 0;" @click="handleCreateApp">
          {{ $t('app_list.btn_create') }}
        </el-button>
      </div>
      <div class="app-list-box">
        <el-skeleton :loading="loading" animated>
          <template #template>
            <loading-app />
          </template>
          <template #default>
            <div v-if="paramAppList.total > 0">
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="8" :xl="8" v-for="(items, key) in dataListPairingStore" :key="key" class="app-list-col">
                  <div class="app-list-container" @click="handleDetailApp(items)">
                    <div class="content-box">
                      <div class="logo">
                        <img v-if="items.app_logo" :src="items.app_logo_xs" height="62" />
                        <img v-else src="@/assets/images/ols-logo-cloude.png" height="62" />
                      </div>
                      <div>
                        <div class="mt-4 mb-4"> {{ items.store_url_id }} </div>
                        <div class="mt-4 mb-4">
                          <el-button
                            :type="items.status === 'A' ? 'success' : 'warning'"
                            size="small"
                          >
                            {{ items.status === 'A' ? 'Aproved' : 'Pending' }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div class="content-box font-14">
                      <div class="app-list"> App_id: </div>
                      <div class="app-list-value font-w-semi-bold"> {{ items.app_id }} </div>
                    </div>
                    <div class="content-box font-14">
                      <div class="store-id"> Store_id: </div>
                      <div class="store-id-value font-w-semi-bold"> {{ items.store_url_id }} </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row justify="center">
                <pagination
                  :total="paramAppList.total"
                  :page="paramAppList.page"
                  :per-page="paramAppList.per_page"
                  @current-change="changePage"
                  class="mt-8"
                />
              </el-row>
            </div>
            <div v-else>
              <el-empty
                description="Data not available"
                style="background: #f4f4f4;border-radius: 8px;"
              />
            </div>
          </template>
        </el-skeleton>
      </div>
    </div>
    <router-view v-if="!isLogginApp"></router-view>
  </div>
</template>

<script setup>
import { watchEffect, onMounted, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getToken } from '@/utils/auth'
import { listPairingStore } from '@/api/endpoints/catalog/authOlsera.js'
// import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import LoadingApp from '@/components/layout/LoadingApp.vue'
import Pagination from '@/components/layout/Pagination.vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'

const store = useStore()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const loadingLogoutOlsera = ref(false)
const isLogginApp = ref(false)
const dataListPairingStore = ref([])
const paramAppList = reactive({
  page: 1,
  per_page: 9,
  total: 0
})

watchEffect(() => {
  const token = getToken('token-olsera')
  if (token) {
    isLogginApp.value = true
  } else {
    isLogginApp.value = false
  }
})
onMounted(() => {
  if (isLogginApp.value) {
    getDataListPairingStore()
  }
})
const handleLoginApp = () => {
  router.push({ path: '/console/login-app' })
}
const handleCreateApp = () => {
  router.push({ path: '/console/store-list' })
}
const handleDetailApp = (payload) => {
  router.push({ path: '/app-detail', query: { id: payload.id }})
}
const getDataListPairingStore = () => {
  loading.value = true
  listPairingStore(paramAppList).then((response) => {
    dataListPairingStore.value = response.data.data
    paramAppList.total = response.data.meta.total
    loading.value = false
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
    loading.value = false
  })
}
const handleLogoutOlsera = () => {
  loadingLogoutOlsera.value = true
  store.dispatch('app/disFetchOlseraToken').then(response => {
    loadingLogoutOlsera.value = false
    isLogginApp.value = false
  }).catch(() => {
    loadingLogoutOlsera.value = false
  })
}
const changePage = (page) => {
  paramAppList.page = page
  getDataListPairingStore()
}
</script>
